export default "__VITE_ASSET__3744c808__"